import React, { useMemo, useEffect, useRef, useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { Modal, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import Search from '@/pages/intelligence/components/SearchRecent/components/Search';
import { addSeachRecord, seachRecordList } from '@/pages/intelligence/services/common';
import { deleteGlobalViewSearchRecord } from '@/pages/intelligence/services/globalView';
import { buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import './index.scss';
import { getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';

export default function SearchRecent(props: any) {
  const {
    searchType,
    disabled,
    // 表示原始数据中，用于表示搜索词的key值，默认为name
    dataNameKey = 'name',
    // 默认会附加searchKey，这个参数为true的时候不附加
    isOuterSearchKey,
    searchKey = 'search_by_name',
    fetchParams /** 页面的参数 */,
    isFrontEndSearch,
    /** 搜索接口：展示在搜索框的列表结果的接口 */
    searchListApi = () => console.log,
    getTableResultList /** 表格接口：点击后重新请求表格接口的接口 */,
    handleClear: handleClearProp = () => console.log /** 清除接口 */,
    searchType: searchTypeProp /** 接口用的搜索类型--区分哪个页面 */,
    pageLogInfo /** 搜索打点 */,
    /** 将搜索记录格式转为搜索展示格式 */
    transRecordDataForSearch = () => console.log,
    /** 将表格的格式转为搜索展示格式  */
    transTableDataForSearch = () => console.log,
    hightLinghtKeyWord = true, // 搜索是否高亮关键字
    initSearchInput,
    placeholder,
    isCustomRendering,
    getAddRecordParams,
    getDeleteRecordParams,
    setSearchLoading,
    resetSearchType,
    updateFlagOfAutoCompleteOptions,
  } = props;

  const locale = getLocale();
  const isCN = useMemo(() => locale === LANGUAGE_CN, [locale]);
  const [loading, setLoading] = useState(false);
  const [recentRecordList, setRecentRecordList] = useState<any[]>([]);
  const [searchResultList, setSearchResultList] = useState<any[]>([]);
  // 搜索请求接口防抖--用最新的那个返回值
  const inputKey = useRef(0);

  /** 搜索历史记录 */
  const getRecentRecord = async () => {
    setLoading(true);
    setRecentRecordList([]);
    setSearchResultList([]);
    try {
      const result = await seachRecordList({
        type: searchType,
      });
      /** 对历史记录数据进行处理，并只要前5 TODO--目前后端做*/
      const transList = transRecordDataForSearch(result);
      setRecentRecordList(transList);
    } catch (err) {}
    setLoading(false);
  };

  /** 获取搜索结果列表--展示在搜索框 */
  const getSearchResultList = async (inputValue: string, type: string) => {
    /** 展示状态： Loading \ 数据 \ 空态 */
    setLoading(true);
    return new Promise((resolve, reject) => {
      if (isFrontEndSearch) {
        const transList = transTableDataForSearch(inputValue);
        setLoading(false);
        setSearchLoading(false);
        resolve(transList);
      } else {
        const appendParams = isOuterSearchKey
          ? {}
          : {
              [searchKey]: inputValue,
            };
        searchListApi({
          ...fetchParams(inputValue, type),
          ...appendParams,
        })
          .then((result: any) => {
            const transList = transTableDataForSearch(result);
            resolve(transList);
            setLoading(false);
            setSearchLoading(false);
          })
          .catch(() => {
            resolve([]);
            setLoading(false);
            setSearchLoading(false);
          });
      }
    });
  };

  /** 点击搜索结果对应条目展示在表格上 */
  const clickSearchItem = async (type: 'record' | 'search', cvm: RecordItemType) => {
    /** 添加条目到历史记录 */
    if (type !== 'record') {
      addRecordItem(cvm);
    }
    if (getTableResultList instanceof Function) {
      setSearchLoading(true);
      if (isFrontEndSearch) {
        getTableResultList(cvm);
        // 点击历史记录，数据需要从接口重新取
      } else {
        getSearchResultList(cvm?.[dataNameKey], 'clickRecord').then((result: any) => {
          const apiCurrent = inputKey.current;
          /** input 输入框频繁请求接口，正确的显示最后一次接口返回的数据 */
          if (apiCurrent === inputKey.current) {
            getTableResultList(result);
          }
        });
      }
    }
  };

  /** 输入搜索关键值 */
  const handleChangeInput = (inputValue: string) => {
    setSearchResultList([]);
    inputKey.current = inputKey.current + 1;
    getSearchResultList(inputValue, 'search').then((result: any) => {
      const { list = [] } = result || {};
      const apiCurrent = inputKey.current;
      /** input 输入框频繁请求接口，正确的显示最后一次接口返回的数据 */
      if (apiCurrent === inputKey.current) {
        setSearchResultList(list);
      }
    });
    // 添加搜索打点
    if (pageLogInfo?.pageId) {
      buriedPointSearch({ extInfo: pageLogInfo?.pageId, typeId: pageLogInfo?.typeId }, inputValue);
    }
  };

  /** 点X清除 */
  const handleClear = () => {
    /** 重新展示历史记录 */
    getRecentRecord();
    handleClearProp();
  };

  const addRecordItem = (item: any) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = getAddRecordParams(item);
    addSeachRecord({
      add_message: [
        Object.assign(params, {
          type: searchType,
        }),
      ],
    });
  };

  /** 删除某个历史记录 */
  const deleteRecordItem = async (item: any) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = getDeleteRecordParams(item);
    const result = await deleteGlobalViewSearchRecord(
      Object.assign(params, {
        type: searchType,
      }),
    );
    if (result.code === 0) {
      getRecentRecord();
    } else {
      Modal.error({
        message: 'Sorry',
        description: 'Data cannot be deleted !',
        buttons: [<Button type="primary">Got it!</Button>],
        size: 'm',
      });
    }
  };

  const renderComp = useMemoizedFn(
    (
      item: any,
      {
        triggerCompClick,
        onClearIcon,
        showClearIcon,
      }: {
        triggerCompClick: Function;
        onClearIcon: Function;
        showClearIcon: boolean;
      },
    ) => {
      const { name, name_cn, icon } = item;
      const nameText = isCN ? name_cn || name : name;
      return (
        <div
          className="dbi-recent-flex dbi-top-genre-market-recent-search-overlay"
          onClick={() => {
            triggerCompClick(item);
          }}
        >
          <div className="recent-left" key={nameText}>
            {icon && <img className="flex-county" src={icon} alt="" width={24} height={16} />}
            <span className="flex-text">{nameText}</span>
          </div>
          {showClearIcon && (
            <div
              className="recent-right"
              onClick={() => {
                if (onClearIcon instanceof Function) {
                  onClearIcon(item);
                }
              }}
            >
              <SvgIcon type="clear-icon" className="recent-icon" />
            </div>
          )}
        </div>
      );
    },
  );

  useEffect(() => {
    if (searchType) {
      getRecentRecord();
    }
  }, [searchType]);

  return (
    <Search
      isAutoSelectWhenOnlyOneSearchResult
      triggerInputChangeEventWhenEmptyInput
      disabled={disabled}
      loading={loading}
      resetSearchType={resetSearchType}
      handleChangeInput={handleChangeInput}
      recentRecordList={recentRecordList}
      searchResultList={searchResultList}
      initSearchInput={initSearchInput}
      placeholder={placeholder}
      handleClear={handleClear}
      clickSearchItem={clickSearchItem}
      deleteRecordItem={deleteRecordItem}
      getRecentRecord={getRecentRecord}
      hightLinghtKeyWord={hightLinghtKeyWord}
      isCustomRendering={isCustomRendering}
      renderComp={renderComp}
      defaultNameStr="name"
      nameStr={isCN ? 'name_cn' : 'name'}
      updateFlagOfAutoCompleteOptions={updateFlagOfAutoCompleteOptions}
    />
  );
}
